export const getAlerts = (state) => state.alerts.alerts;
export const getCountdown = (state) => state.alerts.countdown;
